import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCustomFieldValuesByApplicationId } from 'store/loanApplications/selectors/customFieldValues.selectors';
import { selectCustomFields } from 'store/system/selectors/customFieldDefinitions.selectors';

import {
  buildEntitiesCustomFieldsPendingChangesMap,
  filterDisplayableEnabledDefinitionsForTarget,
} from '../CustomFieldsSection.utils';

const useEntitiesCustomFieldsPendingChangesMap = ({ applicationId, target, entityIds }) => {
  const allDefinitions = useSelector(selectCustomFields);
  const selectValues = useMemo(
    () => selectCustomFieldValuesByApplicationId(applicationId),
    [applicationId],
  );
  const customFieldValues = useSelector(selectValues);

  const definitions = useMemo(
    () => filterDisplayableEnabledDefinitionsForTarget(allDefinitions, target),
    [allDefinitions, target],
  );

  return useMemo(
    () =>
      buildEntitiesCustomFieldsPendingChangesMap({
        definitions,
        values: customFieldValues,
        entityIds,
      }),
    [definitions, customFieldValues, entityIds],
  );
};

export default useEntitiesCustomFieldsPendingChangesMap;
